import { render, staticRenderFns } from "./EmployeeSection.vue?vue&type=template&id=ff3a2c14&scoped=true&"
import script from "./EmployeeSection.vue?vue&type=script&lang=js&"
export * from "./EmployeeSection.vue?vue&type=script&lang=js&"
import style0 from "./EmployeeSection.vue?vue&type=style&index=0&id=ff3a2c14&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff3a2c14",
  null
  
)

export default component.exports